import Vue from "vue";
import './plugins/vuetify'
import App from "./App.vue";
import router from "./router/";
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import VuetifyConfirm from "vuetify-confirm"
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

// Extracto para verificar usuario logeado
router.beforeEach((to, from, next) => {
  if (to.matched.some( record => record.meta.requiresAuth ) && typeof window.localStorage.session === 'undefined' ) {
    next({
      path: '/',
    })
  } else {
    if( to.matched.some( record => record.path === '/login' ) && typeof window.localStorage.session !== 'undefined' ){
      next({
        path: '/tablero',
      })
    } else {
      next()
    }
  }
});


moment.tz.setDefault('America/Lima')
Vue.use(VueMoment, {
    moment,
})

Vue.use(VuetifyConfirm, {
  buttonTrueText: 'Si',
  buttonFalseText: 'No',
  color: 'warning',
  icon: 'error',
  title: '',
  width: 350,
  property: '$confirm'
})

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
